import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Focus from "@/pages/home/components/Focus";
import Feed from "@/pages/home/components/Feed";
import Timeline from "@/pages/home/components/Timeline";
import Special from "@/pages/home/components/Special";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer from "@/pages/home/components/Footer";
import BackTop from "@/pages/home/components/BackTop";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <Focus />
        <Feed />
        <Timeline />
        <Special />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}